import styled from "styled-components"

const Button = styled.button`
    padding: 10px;
    border: 0;
    background-color: #f3e4cd;
    color: #232b32;
    border-radius: 5px;
    margin-right: 10px;
`

export default Button
